module.exports = __webpack_public_path__ + "media/backgrounds/diamond-array-dark-purple-fb7d1304.png";